import { __extends } from "tslib";
import { TaskBase } from './TaskBase';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var ThresholdTask = /** @class */ (function (_super) {
    __extends(ThresholdTask, _super);
    function ThresholdTask() {
        var _this = _super.call(this) || this;
        _this._opDecode = {
            '<': 'slt ',
            '<=': 'sge ',
            '>': 'slt ',
            '>=': 'sge ',
            '==': 'seq ',
            '!=': 'sne '
        };
        _this._thDecode = {
            '<': false,
            '<=': true,
            '>': true,
            '>=': false,
            '==': false,
            '!=': false
        };
        _this._operation = '<';
        _this._op = 'slt ';
        _this._th = false;
        _this._threshold = 0;
        _this._thresholdRGBA = new Float32Array([0, 0, 0, 0]);
        _this._color = 0;
        _this._mask = 0;
        _this._copySource = false;
        _this.bitmapSamplerIndex = 0;
        _this._fragmentConstantData = new Float32Array([
            0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0,
            65025.0, 255.0, 1.0, 16581375.0,
            0.0, 0.0, 0.0, 0.0, // rect
        ]);
        _this._colorRGBA = _this._fragmentConstantData.subarray(4, 4 * 2);
        _this._maskRGBA = _this._fragmentConstantData.subarray(4 * 2, 4 * 3);
        _this._decodeVector = _this._fragmentConstantData.subarray(4 * 3, 4 * 4);
        _this._rect = _this._fragmentConstantData.subarray(4 * 4, 4 * 5);
        return _this;
    }
    Object.defineProperty(ThresholdTask.prototype, "operation", {
        get: function () {
            return this._operation;
        },
        set: function (value) {
            if (this._operation == value)
                return;
            this._operation = value;
            this._op = this._opDecode[value];
            this._th = this._thDecode[value];
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThresholdTask.prototype, "threshold", {
        get: function () {
            return this._threshold;
        },
        set: function (value) {
            if (this._threshold == value)
                return;
            this._threshold = value;
            this._thresholdRGBA.set([
                ((value >> 16) & 0xff) / 0xff,
                ((value >> 8) & 0xff) / 0xff,
                (value & 0xff) / 0xff,
                ((value >> 24) & 0xff) / 0xff
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThresholdTask.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            if (this._color == value)
                return;
            this._color = value;
            //pre-multiply alpha
            var alpha = ((value >> 24) & 0xff) / 0xff;
            this._colorRGBA.set([
                alpha * ((value >> 16) & 0xff) / 0xff,
                alpha * ((value >> 8) & 0xff) / 0xff,
                alpha * (value & 0xff) / 0xff,
                alpha
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThresholdTask.prototype, "mask", {
        get: function () {
            return this._mask;
        },
        set: function (value) {
            if (this._mask == value)
                return;
            this._mask = value;
            this._maskRGBA.set([
                ((value >> 16) & 0xff) / 0xff,
                ((value >> 8) & 0xff) / 0xff,
                (value & 0xff) / 0xff,
                ((value >> 24) & 0xff) / 0xff
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThresholdTask.prototype, "copySource", {
        get: function () {
            return this._copySource;
        },
        set: function (value) {
            if (this._copySource == value)
                return;
            this._copySource = value;
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    ThresholdTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp2, 1);
        var temp3 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp3, 1);
        var sourceTexture = this._registerCache.getFreeTextureReg();
        this.sourceSamplerIndex = sourceTexture.index;
        var bitmapTexture = this._registerCache.getFreeTextureReg();
        this.bitmapSamplerIndex = bitmapTexture.index;
        var threshold = this._registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = threshold.index;
        var color = this._registerCache.getFreeFragmentConstant();
        var mask = this._registerCache.getFreeFragmentConstant();
        var decode = this._registerCache.getFreeFragmentConstant();
        var rect = this._registerCache.getFreeFragmentConstant();
        var code = 'mul ' + temp1 + ', ' + this._uvVarying + ', ' + rect + '.zw\n' +
            'add ' + temp1 + ', ' + temp1 + ', ' + rect + '.xy\n' +
            'tex ' + temp1 + ', ' + temp1 + ', ' + bitmapTexture + ' <2d,linear,clamp>\n' +
            'mul ' + temp2 + ', ' + temp1 + ', ' + mask + '\n' +
            'dp4 ' + temp2 + ', ' + temp2 + ', ' + decode + '\n' +
            // eslint-disable-next-line max-len
            this._op + temp2 + ', ' + (this._th ? threshold : temp2) + ', ' + (this._th ? temp2 : threshold) + '\n' +
            'sub ' + temp3 + ', ' + decode + '.zzzz, ' + temp2 + '\n' +
            'mul ' + temp2 + ', ' + temp2 + ', ' + color + '\n';
        if (this._copySource) {
            code = code + 'mul ' + temp3 + ', ' + temp3 + ', ' + temp1 + '\n' +
                'add ' + temp1 + ', ' + temp2 + ', ' + temp3 + '\n' +
                'mov oc, ' + temp1 + '\n';
        }
        else {
            code = code + 'tex ' + temp1 + ', ' + this._uvVarying + ', ' + sourceTexture + ' <2d,linear,clamp>\n' +
                'mul ' + temp3 + ', ' + temp3 + ', ' + temp1 + '\n' +
                'add ' + temp1 + ', ' + temp2 + ', ' + temp3 + '\n' +
                'mov oc, ' + temp1 + '\n';
        }
        this._registerCache.removeFragmentTempUsage(temp3);
        this._registerCache.removeFragmentTempUsage(temp2);
        this._registerCache.removeFragmentTempUsage(temp1);
        return code;
    };
    ThresholdTask.prototype.activate = function (stage, projection, depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var thRGBA = this._thresholdRGBA;
        var maskRGBA = this._maskRGBA;
        var decRGBA = this._decodeVector;
        // this is equal dot(threshold * mask, decode)
        var tValue = (thRGBA[0] * maskRGBA[0] * decRGBA[0] +
            thRGBA[1] * maskRGBA[1] * decRGBA[1] +
            thRGBA[2] * maskRGBA[2] * decRGBA[2] +
            thRGBA[3] * maskRGBA[3] * decRGBA[3]);
        var index = this._fragmentConstantsIndex;
        var data = this._fragmentConstantData;
        data[index] = tValue;
        data[index + 1] = tValue;
        data[index + 2] = tValue;
        data[index + 3] = tValue;
        data[index + 16] = (this.mapPoint.x - this.inputRect.x) / this.bitmap.width;
        data[index + 17] = (this.mapPoint.y - this.inputRect.y) / this.bitmap.height;
        data[index + 18] = this._source.width / this.bitmap.width;
        data[index + 19] = this._source.height / this.bitmap.height;
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, this._vertexConstantData);
        context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, this._fragmentConstantData);
        stage.abstractions.getAbstraction(this._source).activate(this.sourceSamplerIndex);
        stage.abstractions.getAbstraction(this.bitmap).activate(this.bitmapSamplerIndex);
    };
    return ThresholdTask;
}(TaskBase));
export { ThresholdTask };
